import omit from "lodash.omit"
import { SVGAttributes } from "react"
import { styled, callCSSFn, StylePropsWithCSS, WithCSS } from "../styles"
import { useTheme } from "../theme"

type SearchVariants = "legacy" | "white"

type SearchIconProps = SVGAttributes<SVGElement> & {
  variant?: SearchVariants
} & WithCSS

export const SearchIconSVG = ({ fill, ...props }: SearchIconProps) => (
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...omit(props, `css`)}>
    <path
      d="M13.7775 15.1726C14.0661 15.4611 14.5339 15.4611 14.8225 15.1726C15.111 14.884 15.111 14.4162 14.8225 14.1276L13.7775 15.1726ZM11.6083 10.9135C11.3198 10.6249 10.8519 10.6249 10.5634 10.9135C10.2748 11.202 10.2748 11.6699 10.5634 11.9584L11.6083 10.9135ZM12.0833 7.26121C12.0833 10.1177 9.76765 12.4334 6.91111 12.4334V13.9112C10.5838 13.9112 13.5611 10.9339 13.5611 7.26121H12.0833ZM6.91111 12.4334C4.05457 12.4334 1.73889 10.1177 1.73889 7.26121H0.261111C0.261111 10.9339 3.23842 13.9112 6.91111 13.9112V12.4334ZM1.73889 7.26121C1.73889 4.40467 4.05457 2.08899 6.91111 2.08899V0.611209C3.23842 0.611209 0.261111 3.58852 0.261111 7.26121H1.73889ZM6.91111 2.08899C9.76765 2.08899 12.0833 4.40467 12.0833 7.26121H13.5611C13.5611 3.58852 10.5838 0.611209 6.91111 0.611209V2.08899ZM14.8225 14.1276L11.6083 10.9135L10.5634 11.9584L13.7775 15.1726L14.8225 14.1276Z"
      fill={fill}
    />
  </svg>
)

SearchIconSVG.defaultProps = {
  variant: undefined,
}

const SearchIconComponent = ({ variant, ...rest }: SearchIconProps) => {
  const theme = useTheme()
  switch (variant) {
    case `legacy`:
      return <SearchIconSVG fill={theme.palette.grey.dark} {...rest} />
    case `white`:
      return <SearchIconSVG fill={theme.palette.white} {...rest} />
    default:
      return <SearchIconSVG fill={theme.palette.coal.dark} {...rest} />
  }
}

SearchIconComponent.defaultProps = {
  variant: undefined,
}

export const SearchIcon = styled(SearchIconComponent)((props: StylePropsWithCSS) => ({
  ...callCSSFn(props),
}))
